import { Job } from "../models/Job";
import { getAuthHeaders } from "../utils/authHeaders";
import { API_URL } from "../config/api";

export interface SavedJob {
  id: string;
  jobId: string;
  userId: string;
  savedAt: string;
  job?: Job; // Populated when fetching saved jobs
}

// Save a job for the current user
export const saveJob = async (jobId: string): Promise<SavedJob> => {
  try {
    
    const response = await fetch(`${API_URL}/saved-jobs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      credentials: 'include',
      body: JSON.stringify({ jobId }),
    });

    if (!response.ok) {
      throw new Error('Failed to save job');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('❌ Error saving job:', error);
    throw error;
  }
};

// Remove a saved job for the current user
export const unsaveJob = async (jobId: string): Promise<void> => {
  try {
    
    const response = await fetch(`${API_URL}/saved-jobs/${jobId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to remove saved job');
    }

    console.log('✅ Job removed from saved jobs');
  } catch (error) {
    console.error('❌ Error removing saved job:', error);
    throw error;
  }
};

// Get all saved jobs for the current user
export const getSavedJobs = async (): Promise<SavedJob[]> => {
  try {
    console.log('📋 Fetching saved jobs...');
    
    const response = await fetch(`${API_URL}/saved-jobs`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch saved jobs');
    }

    const data = await response.json();
    console.log('✅ Saved jobs fetched:', data.length, 'jobs');
    return data;
  } catch (error) {
    console.error('❌ Error fetching saved jobs:', error);
    throw error;
  }
};

// Check if a job is saved by the current user
export const isJobSaved = async (jobId: string): Promise<boolean> => {
  try {
    
    const response = await fetch(`${API_URL}/saved-jobs/check/${jobId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      credentials: 'include',
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    console.log('✅ Job save status:', data.isSaved);
    return data.isSaved;
  } catch (error) {
    console.error('❌ Error checking saved job:', error);
    return false;
  }
};

// Get count of saved jobs for the current user
export const getSavedJobsCount = async (): Promise<number> => {
  try {
    console.log('📊 Fetching saved jobs count...');
    
    const response = await fetch(`${API_URL}/saved-jobs/count`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      credentials: 'include',
    });

    if (!response.ok) {
      return 0;
    }

    const data = await response.json();
    console.log('✅ Saved jobs count:', data.count);
    return data.count;
  } catch (error) {
    console.error('❌ Error fetching saved jobs count:', error);
    return 0;
  }
};
